import { Location } from "@angular/common";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";

export class ScreenInitialLoading {
  public visible = false;
  private timer: any;

  constructor(private readonly delayMs = 300, private readonly onChange?: (visible: boolean) => void) {}

  public begin(isEmpty: boolean, isLoading: () => boolean): void {
    this.clear();
    if (!isEmpty) {
      this.setVisible(false);
      return;
    }
    this.timer = setTimeout(() => {
      if (isLoading()) {
        this.setVisible(true);
      }
    }, this.delayMs);
  }

  public finish(): void {
    this.clear();
    this.setVisible(false);
  }

  public destroy(): void {
    this.clear();
  }

  private clear(): void {
    if (!this.timer) {
      return;
    }
    clearTimeout(this.timer);
    this.timer = null;
  }

  private setVisible(visible: boolean): void {
    this.visible = visible;
    if (this.onChange) {
      this.onChange(visible);
    }
  }
}

export function navigateBackOrFallback(location: Location, router: Router, fallbackCommands: any[]): void {
  if (hasAngularBackNavigation()) {
    location.back();
    return;
  }
  router.navigate(fallbackCommands);
}

export function hasAngularBackNavigation(): boolean {
  const state = window.history && window.history.state ? window.history.state : null;
  if (typeof state?.nogoshCanGoBack === "boolean") return state.nogoshCanGoBack;
  return !!(state && Number(state.navigationId || 0) > 1);
}

// A navigation ID also increases for redirects. Track actual app entries so a
// direct link does not send Back to Auth0 or an unrelated external website.
export function trackAppHistory(router: Router): void {
  let hasEntry = false;
  let canGoBack = false;
  router.events.subscribe(event => {
    if (event instanceof NavigationStart) {
      const existing = window.history.state?.nogoshCanGoBack === true;
      canGoBack = event.navigationTrigger === 'popstate'
        ? event.restoredState?.['nogoshCanGoBack'] === true
        : !hasEntry || router.getCurrentNavigation()?.extras.replaceUrl ? existing : true;
    }
    if (event instanceof NavigationEnd) {
      window.history.replaceState({...window.history.state, nogoshCanGoBack: canGoBack}, '');
      hasEntry = true;
    }
  });
}
